import global from './global';
import auth from './auth';
import question from './question';
import userData from './user-data';
import information from './information';
import year from './year';
import regist from './regist';
import order from './order';
import inquiry from './inquiry';
import exam from './exam';
import event from './event';

//各 reducerをコンバイン
// import hoge1 from './hoge1';
// import hoge2 from './hoge2';
// export { hoge1 ,hoge2, }
// ここで export されたモジュールは ../store/ にて取り込まれる。

export default {
  global,
  auth,
  question,
  userData,
  information,
  year,
  regist,
  order,
  inquiry,
  exam,
  event,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js